(function () {
    function safeInit(initializer, element) {
        if (!initializer || !element || typeof initializer.init !== 'function') {
            return;
        }

        try {
            initializer.init(element);
        } catch (error) {
            console.warn('Vitalify theme module failed to initialize.', {
                element: element,
                initializer: initializer,
                error: error
            });
        }
    }

    function initNodeList(nodeList, initializer) {
        if (!initializer || !nodeList.length) {
            return;
        }

        nodeList.forEach(function (element) {
            safeInit(initializer, element);
        });
    }

    function initThemeModules() {
        var bannerSliderElements = document.querySelectorAll('[data-banner-slider]');
        var homeProductSliderElements = document.querySelectorAll('[data-home-product-slider]');
        var homeCategoriesSliderElements = document.querySelectorAll('[data-home-categories-slider]');
        var homeOfferSliderElements = document.querySelectorAll('[data-home-offer-slider]');
        var homeInstagramElements = document.querySelectorAll('[data-home-instagram]');
        var homeReviewsElements = document.querySelectorAll('[data-home-reviews]');
        var headerElement = document.querySelector('[data-site-header]');
        var mainCollectionElements = document.querySelectorAll('[data-main-collection]');
        var secondSectionElements = document.querySelectorAll('[data-second-section]');
        var productHeroElements = document.querySelectorAll('[data-product-hero]');
        var productReviewsElements = document.querySelectorAll('[data-product-reviews]');
        var productRelatedElements = document.querySelectorAll('[data-product-related]');
        var siteFooterElements = document.querySelectorAll('[data-site-footer]');
        var stickyAtcElements = document.querySelectorAll('[data-sticky-atc]');

        initNodeList(bannerSliderElements, window.VitalifyBannerSlider);
        initNodeList(secondSectionElements, window.VitalifySecondSection);
        initNodeList(homeCategoriesSliderElements, window.VitalifyHomeCategoriesSlider);
        initNodeList(homeProductSliderElements, window.VitalifyHomeFeaturedCollection);
        initNodeList(homeOfferSliderElements, window.VitalifyHomeOfferBanner);
        initNodeList(homeInstagramElements, window.VitalifyHomeInstagram);
        initNodeList(homeReviewsElements, window.VitalifyHomeReviews);

        if (window.VitalifySiteHeader && headerElement) {
            safeInit(window.VitalifySiteHeader, headerElement);
        }

        if (window.VitalifyCartDrawer && headerElement) {
            safeInit(window.VitalifyCartDrawer, headerElement);
        }

        initNodeList(mainCollectionElements, window.VitalifyMainCollection);
        initNodeList(productHeroElements, window.VitalifyProductHero);
        initNodeList(productReviewsElements, window.VitalifyJudgeMe);
        initNodeList(productRelatedElements, window.VitalifyProductRelated);
        initNodeList(siteFooterElements, window.VitalifySiteFooter);
        initNodeList(stickyAtcElements, window.VitalifyStickyAtc);
    }

    function initWithinTarget(target) {
        if (!target) {
            return;
        }

        initNodeList(target.querySelectorAll('[data-banner-slider]'), window.VitalifyBannerSlider);
        initNodeList(target.querySelectorAll('[data-second-section]'), window.VitalifySecondSection);
        initNodeList(target.querySelectorAll('[data-home-categories-slider]'), window.VitalifyHomeCategoriesSlider);
        initNodeList(target.querySelectorAll('[data-home-product-slider]'), window.VitalifyHomeFeaturedCollection);
        initNodeList(target.querySelectorAll('[data-home-offer-slider]'), window.VitalifyHomeOfferBanner);
        initNodeList(target.querySelectorAll('[data-home-instagram]'), window.VitalifyHomeInstagram);
        initNodeList(target.querySelectorAll('[data-home-reviews]'), window.VitalifyHomeReviews);
        if (window.VitalifySiteHeader) {
            var siteHeaderElement = target.matches && target.matches('[data-site-header]')
                ? target
                : target.querySelector && target.querySelector('[data-site-header]');

            if (siteHeaderElement) {
                safeInit(window.VitalifySiteHeader, siteHeaderElement);
            }
        }
        if (window.VitalifyCartDrawer) {
            var headerElement = target.matches && target.matches('[data-site-header]')
                ? target
                : target.querySelector && target.querySelector('[data-site-header]');

            if (headerElement) {
                safeInit(window.VitalifyCartDrawer, headerElement);
            }
        }
        initNodeList(target.querySelectorAll('[data-main-collection]'), window.VitalifyMainCollection);
        initNodeList(target.querySelectorAll('[data-product-hero]'), window.VitalifyProductHero);
        if (window.VitalifyJudgeMe) {
            var productReviewsElement = target.matches && target.matches('[data-product-reviews]')
                ? target
                : target.querySelector && target.querySelector('[data-product-reviews]');

            if (productReviewsElement) {
                safeInit(window.VitalifyJudgeMe, productReviewsElement);
            }
        }
        initNodeList(target.querySelectorAll('[data-product-related]'), window.VitalifyProductRelated);
        initNodeList(target.querySelectorAll('[data-site-footer]'), window.VitalifySiteFooter);
        initNodeList(target.querySelectorAll('[data-sticky-atc]'), window.VitalifyStickyAtc);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initThemeModules);
    } else {
        initThemeModules();
    }

    window.addEventListener('load', initThemeModules);
    window.setTimeout(initThemeModules, 600);

    document.addEventListener('shopify:section:load', function (event) {
        initWithinTarget(event.target);
    });
})();
